import { render } from "./CodeHighlight.vue?vue&type=template&id=17bddf9c"
import script from "./CodeHighlight.vue?vue&type=script&lang=js"
export * from "./CodeHighlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/syntax/CodeHighlight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17bddf9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17bddf9c', __exports__)) {
    api.reload('17bddf9c', __exports__)
  }
  
  module.hot.accept("./CodeHighlight.vue?vue&type=template&id=17bddf9c", () => {
    api.rerender('17bddf9c', render)
  })

}


export default __exports__